import { Component } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'quote-hub-auth-layout',
    imports: [RouterOutlet],
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  assetsConst = assets;
}
